// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S5b7J","upload":"styles_upload__B2MU4","fileTitle":"styles_fileTitle__AGizR","fileFormat":"styles_fileFormat__iqEub"};